import { manageAxios } from "@/config/axios";
import { AxiosResponse } from "axios";

export function getNotices(hasRead: boolean, params?: {}): Promise<AxiosResponse<any>> {
    return manageAxios.get(`/find-notices`, {
        params: {
            ...params,
            hasRead: hasRead
        }
    })
}

export function readNotice(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return manageAxios.post(`/read-notice`, null, {
        params: {
            ...params,
            id: id
        }
    })
}
